import { type ExposureStatisticData } from '../../../models/exposure-statistic/exposure-statistics-types'
import { type ExposureStatisticDataGridRow } from '../../../pages/exposure-statistic/exposure-statistic-data-grid'

export function createExposureStatisticRows (data: ExposureStatisticData[]): ExposureStatisticDataGridRow[] {
  const results: ExposureStatisticDataGridRow[] = []

  if (data != null) {
    data.forEach(item => {
      const id = item.owner + '&&' + item.account_type
      results.push(
        {
          id,
          path: [id],
          ...item
        }
      )
    })
  }

  return results
}
